import type { DeviceInfoType } from '@/types/pt_types'

export function getDeviceInfo(): DeviceInfoType {
  const width = window.innerWidth
  const height = window.innerHeight
  const isLandscape = width > height
  const isTouch = 'ontouchstart' in window
  // 小于 1024 就算移动端
  // (一般都是小于760为移动端，这里用1024是为了让手机横屏和平板竖屏时显示移动端UI)
  const isMobile = width < 1024
  // const isMobile = false
  return { width, height, isLandscape, isTouch, isMobile }
}

export const deviceInfo = ref(getDeviceInfo())

// 设计稿为750,将像素转为vw实现H5响应式
export function rpx2vw(rpx: number) {
  return rpx / 7.5
}

// 将750设计稿的vw转为真实的px
export function vw2Px(vw: number) {
  return (vw * deviceInfo.value.width!) / 100
}
// 将750设计稿的rpx转为真实的px(纯vue3没有rpx，先转为了vw再转成px)
// 自定义的rpx只能在unocss中使用，不能在style里直接使用
export function rpx2Px(rpx: number) {
  return (rpx2vw(rpx) * deviceInfo.value.width!) / 100
}
// 纯vue3没有rpx，自己转为了vw再转为px
export function parsePx(value: string | number, defaultVal?: number) {
  if (value === undefined || value === null) {
    return defaultVal
  }
  if (typeof value === 'number') {
    return Number(value)
  }
  const match = value.trim().match(/^(-?\d+(\.\d+)?)([a-zA-Z%]+)$/)
  if (!match) {
    throw new Error('只支持rpx,px,vw')
  }
  const num = Number(match[1]) // 数字
  const unit = match[3] ? match[3].trim().toLowerCase() : undefined
  if (!unit || unit === 'px') {
    // 没有单位或本身就是px
    return num
  } else if (unit === 'rpx') {
    return rpx2Px(num)
  } else if (unit === 'vw') {
    return vw2Px(num)
  } else {
    // throw new Error('只支持rpx,px,vw')
    return defaultVal
  }
}

// js获取calc的值(通过document计算)
export function calcToPx(calcValue: string): number {
  const el = document.createElement('div')
  el.style.position = 'absolute'
  el.style.visibility = 'hidden'
  el.style.height = calcValue

  document.body.appendChild(el)
  const px = el.getBoundingClientRect().height
  document.body.removeChild(el)

  return px
}
export const navBarHeight = ref(44)
export const tabBarHeight = ref(50)
export const safeTop = ref(0)
export const safeBottom = ref(0)
